import React from 'react';

const SvgMentalHealth = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "tourlane-Careers-MentalHealth__nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "tourlane-Careers-MentalHealth__path-1",
  d: "M16.537 0S9.74 1.717 4.541 10.165C-.657 18.612.03 24.67.03 24.67H0h58.21s.687-6.058-4.511-14.505C49.403 3.184 44.015.255 42.273.045"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-Careers-MentalHealth__path-3",
  d: "M23.981 0c1.641 0 3.244.165 4.793.48l-.006.149-.003.296c0 3.59.57 6.552 3.02 9.309-1.22 2.493-2.337 4.4-2.903 6.589-.566 2.188 5.876 3.587 13.677-.028l-.009.003.019.007.064.018c1.466.352 2.96.7 4.503.945.54 2 .826 4.103.826 6.273 0 13.277-10.736 24.04-23.98 24.04C10.736 48.082 0 37.319 0 24.042 0 10.763 10.737 0 23.981 0z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(15 67.45)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-Careers-MentalHealth__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-Careers-MentalHealth__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#59DD7D",
  xlinkHref: "#tourlane-Careers-MentalHealth__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M21.286 10.438c.511 0 .926.415.926.927v.473a.927.927 0 01-.926.926h-1.337v4.888a.927.927 0 01-.926.927h-.409a.927.927 0 01-.926-.927v-4.889l-1.336.001a.927.927 0 01-.927-.926v-.473c0-.512.415-.927.927-.927h4.934z",
  mask: "url(#tourlane-Careers-MentalHealth__mask-2)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28.885,
  cy: 14.676,
  r: 1.174,
  fill: "#F5F5F5",
  mask: "url(#tourlane-Careers-MentalHealth__mask-2)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28.885,
  cy: 20.131,
  r: 1.174,
  fill: "#F5F5F5",
  mask: "url(#tourlane-Careers-MentalHealth__mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  d: "M24.423 3.076h9.394l-4.697 7.511-4.697-7.51z",
  mask: "url(#tourlane-Careers-MentalHealth__mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(20.139 24.52)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-Careers-MentalHealth__mask-4",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-Careers-MentalHealth__path-3"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#ECECEC",
  xlinkHref: "#tourlane-Careers-MentalHealth__path-3"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#8D8D8D",
  mask: "url(#tourlane-Careers-MentalHealth__mask-4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.37 34.42c.612-.36 1.4-.154 1.758.46a1.29 1.29 0 01-.458 1.762c-2.133 1.253-4.576 1.877-7.307 1.877-2.72 0-5.233-.618-7.52-1.855a1.29 1.29 0 01-.522-1.744 1.283 1.283 0 011.74-.523c1.908 1.03 4.002 1.546 6.302 1.546 2.287 0 4.282-.51 6.007-1.523zM17.579 25.979a1.026 1.026 0 001.452-.046 1.032 1.032 0 00-.046-1.457c-1.406-1.321-3.057-1.996-4.906-1.996-1.837 0-3.527.665-5.033 1.967a1.032 1.032 0 00-.108 1.454c.371.43 1.021.479 1.451.107 1.142-.988 2.36-1.467 3.691-1.467 1.32 0 2.47.47 3.5 1.438zM38.134 25.979a1.026 1.026 0 001.452-.046 1.032 1.032 0 00-.046-1.457c-1.405-1.321-3.056-1.996-4.906-1.996-1.837 0-3.527.665-5.033 1.967a1.032 1.032 0 00-.107 1.454c.37.43 1.02.479 1.45.107 1.142-.988 2.36-1.467 3.69-1.467 1.32 0 2.47.47 3.5 1.438z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#ECECEC",
  d: "M54.652 33.255C52.6 30.971 51.4 28.21 51.4 25.235 51.4 17.373 59.781 11 70.12 11c10.339 0 18.72 6.373 18.72 14.235 0 7.862-8.381 14.235-18.72 14.235-2.517 0-4.855-.526-7.11-1.063-.204-.048-.008-.048-.062-.023-7.891 3.806-11.977 3.182-11.177 1.201.801-1.98 1.818-3.98 3.049-5.996"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M63.36 23.48a2.08 2.08 0 110 4.16 2.08 2.08 0 010-4.16zm7.28 0a2.08 2.08 0 110 4.16 2.08 2.08 0 010-4.16zm7.28 0a2.08 2.08 0 110 4.16 2.08 2.08 0 010-4.16z"
})))));

export default SvgMentalHealth;